
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import GenericImageGenerator from '@owc-utils/GenericImage/GenericImageGenerator';
import GenericImageComponent from '@owc-packages/GenericImage/src/GenericImage.vue';
import { SimpleTeaserItemComponent } from '@owc-packages/SimpleTeaser/src/SimpleTeaser';
import { TagType } from './SimpleTeaser.enums';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';
import Personalisation from '@owc-utils/Mixins/Personalisation';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';

export default (ComponentInitializeDispatcher as SimpleTeaserItemComponent).extend({
  name: 'owc-simple-teaser-item',
  components: {
    GenericImageComponent,
    ValidationBoxWrapper,
  },
  mixins: [OwcDataComponent, Personalisation],
  computed: {
    tags: function() {
      return this.personaliseableData?.tags || [];
    },
    hasTags: function() {
      return Boolean(this.tags?.length);
    },
    links: function() {
      return this.personaliseableData?.links;
    },
    image: function() {
      const data = this.personaliseableData;
      if (data?.showMedia && data?.image) {
        return new GenericImageGenerator(
          this.personaliseableData.image,
          ['mq1', 'mq3', 'mq5'],
          '4x3', // this is the ratio that is defined on specs
        );
      }

      return null;
    },
    copy: function() {
      return this.personaliseableData?.copy;
    },
    bullets: function() {
      return this.personaliseableData?.bullets;
    },
    headline: function() {
      return this.personaliseableData.headline;
    },
  },
  methods: {
    isCta(ctaType: string) {
      return Boolean(ctaType);
    },
    getCtaLinkClasses: function(ctaLinkType: string) {
      if (!this.isCta(ctaLinkType)) {
        return ['wb-link', 'wb-link--standalone'];
      }

      return ['owc-simple-teaser-item-button', 'wb-button', `wb-button--${ctaLinkType}`, 'wb-button--medium'];
    },
    getTagType: function(tagType: number) {
      return TagType[tagType];
    },
  },
});
